// ===
// ngl referrence: http://nglviewer.org/ngl/api/
// ===

import React, { useRef, useState } from "react";
import { Stage, ColormakerRegistry, Selection } from "ngl";
// import {makeImage} from 'ngl/src/viewer/viewer-utils.js'
import Style from "./PDBStructureBase.module.css";
import { getSpikeMutsData } from "../../service/spikeMutsData";
import {getLitRefMutsData} from "../../service/litRefMutsData"
import { pdbciffileurl } from "../../service/endpoint";
import { addThousandSeparator } from "../../util/parseTableData";

import { saveAs } from 'file-saver';
import { GrDownload,GrCatalog } from "react-icons/gr";
import {MdOpenInFull,MdWifiProtectedSetup } from "react-icons/md";
// import { savefile } from "./savefile";
import {getLineageNameIn3DStructDesc,getTopDisclaimerIn3DStructModal} from "../../service/textRetrieval";

import Modal from 'react-bootstrap/Modal';
import BTable from "react-bootstrap/Table";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
// import {  useTable } from "react-table";

const PDBStructureBase = ({
  variant,
  textLiterals
}) => {

  const [lineageNameInDescription, setLineageNameInDescription]=useState("");
  const [topDisclaimerIn3DStructModal, setTopDisclaimerIn3DStructModal]=useState("");

  // const [isLoading, setIsLoading] = React.useState(false);
  // Update Line Graph settings based on scale
  const btnSaveAsImage = useRef();
  const btnSpin = useRef();
  const btnFullscreen = useRef();
  const loader3DSpikeMutations = useRef();
  const btnContainer = useRef();
  const btnLiteratureRef = useRef();

  const [result, setResult] = useState();
  const [visible, setVisible] = React.useState(false);
  const [literatureRef, setLiteratureRef] = React.useState([]);

  const [labelResnoNotFound, setLabelResnoNotFound] = useState("");
  const constColorNonDelInsWithPhenoEffect = "#ff8a04" //"#ff1500" //"#ff3c00"; // orange
  const constColorNonDelInsNoPhenoEffect = "#00cc00"; // green
  const constColorDelInsPhenoEffect = "#00FFFF"; // cyan
  const constColorDelInsNoPhenoEffect = "#00FFFF"; // green
  // const constColorCoMuts = "#00cc00" //green hsl 
  //"#00b300"; //"#00cc00"//"#00e600"; // "#009900";//"#00b300"; - green hsl //"#4d4db3"; // blue

  React.useEffect(() => {
    // window.addEventListener("resize", updateDimensions);
    // return () => window.removeEventListener("resize", updateDimensions);
    window.addEventListener("resize", function (event) {
      if(stage!==undefined)stage.handleResize();
    }, false);
  }, []);

  let [stage,setStage] = useState();
  React.useEffect(()=>{
    setStage(new Stage("viewport3dStructure", { backgroundColor: "white" }));
  },[]);
  
  function addElement(el) {
    Object.assign(el.style, {
      position: "absolute",
      zIndex: 10
    })
    stage.viewer.container.appendChild(el)
  }
  function createElement(name, properties, style) {
    var el = document.createElement(name)
    Object.assign(el, properties)
    Object.assign(el.style, style)
    return el
  }

  React.useEffect(()=>{
    setLineageNameInDescription(getLineageNameIn3DStructDesc(variant,textLiterals));
    getSpikeMutsData(variant).then((result) => {
      if(result&&result.length>0){
        setResult(result);
      }
    });
    setTopDisclaimerIn3DStructModal(getTopDisclaimerIn3DStructModal(variant,textLiterals));
    getLitRefMutsData(variant).then((result) => {
      if(result&&result.length>0){
        setLiteratureRef(result);
      }
    });
  },[variant,textLiterals])

  // React.useEffect(()=>{
  //   let disclaimer=getTopDisclaimerIn3DStructModal(variant,textLiterals);
  //   setTopDisclaimerIn3DStructModal(disclaimer.replace("<utcTimestamp>", countryCountTotalData.utcTimestamp).replace("<totalNumIsolates>", addThousandSeparator(countryCountTotalData.totalNumIsolates)).replace("<variantName>",variantName));
  // },[variant,textLiterals,countryCountTotalData,variantName])

  const handleLiteratureClick = (e) => {
    // console.debug("handleLiteratureClick ...clicked", literatureRef);
    setVisible(true);
  };

  React.useEffect(() => {
    // getPerlData function fetch both posList.json and posWithPhenoEffect.csv
    if(stage){
    // getSpikeMutsData(variant).then((result) => {
      if (result) {
        
        // fullvariantname sample: L242X,A243X,L244X,L144del,ins134L
        let variantArray = result[0].split(",");
        let posPhenoEffectArray = result[1].split(",");

        let variantNonDelInsArray = variantArray.filter(item => (item.slice(-3) !== "del") && (item.slice(0, 3) !== "ins"));
        let variantNonDelInsPhenoEffectArray = [], variantNonDelInsPhenoEffectPosArray = [];
        let variantNonDelInsNoPhenoEffectArray = [], variantNonDelInsNoPhenoEffectPosArray = [];
        // let variantNonDelInsPosArray = variantNonDelInsArray.map(item => item.slice(1, -1));
        for (let i = 0; i < variantNonDelInsArray.length; i++) {
          let item = variantNonDelInsArray[i];
          let pos = item.slice(1, -1);
          if (posPhenoEffectArray.indexOf(pos) > -1) { //found pos
            variantNonDelInsPhenoEffectArray.push(item);
            variantNonDelInsPhenoEffectPosArray.push(pos);
          } else { //not found
            variantNonDelInsNoPhenoEffectArray.push(item);
            variantNonDelInsNoPhenoEffectPosArray.push(pos);
          }
        }
        // console.debug(variantNonDelInsArray, variantNonDelInsPhenoEffectArray, variantNonDelInsNoPhenoEffectArray);
        // console.debug(variantNonDelInsPhenoEffectPosArray, variantNonDelInsNoPhenoEffectPosArray);

        let variantDelInsArray = variantArray.filter(function (el) {
          return variantNonDelInsArray.indexOf(el) < 0;
        });
        // let variantDelInsPosArray = variantDelInsArray
        //   .map((item) => (item.slice(-3) === "del") ? item.slice(1, -3) : (item.slice(0, 3) === "ins" ? item.slice(3, -1) : item.slice(1, -1)));
        let variantDelInsPhenoEffectArray = [], variantDelInsPhenoEffectPosArray = [];
        let variantDelInsNoPhenoEffectArray = [], variantDelInsNoPhenoEffectPosArray = [];
        // let variantNonDelInsPosArray = variantNonDelInsArray.map(item => item.slice(1, -1));
        for (let i = 0; i < variantDelInsArray.length; i++) {
          let item = variantDelInsArray[i];
          let pos = (item.slice(-3) === "del") ? item.slice(1, -3) : (item.slice(0, 3) === "ins" ? item.slice(3, -3) : item.slice(1, -1));
          if (posPhenoEffectArray.indexOf(pos) > -1) { //found pos
            variantDelInsPhenoEffectArray.push(item);
            variantDelInsPhenoEffectPosArray.push(pos);
          } else { //not found
            variantDelInsNoPhenoEffectArray.push(item);
            variantDelInsNoPhenoEffectPosArray.push(pos);
          }
        }
        // stage = new Stage("viewport3dStructure", { backgroundColor: "white" });
        //  stage.removeAllComponents();
        // stage.dispose();

        // stage.removeAllComponents();
        // stage.loadFile("6acj-cus.cif", { ext: 'cif', defaultRepresentation: true }).then(function (o) {
        stage.loadFile(pdbciffileurl, { ext: 'cif' }).then(function (o) {
          // o.setScale( 150 );// this line has to be after stage.autoview(), autoview will look for center
          // o.setPosition([264, 264,0]); // this line has to be after stage.autoview(), autoview will look for center
          o.setRotation([89.6, 270.2, 89.5]); // rotation around x-axis, y-axis, z-axis

          var ace2 = o.addRepresentation("cartoon", { color: "#00FF00", radiusType: "sstruc" });
          // o.addRepresentation("cartoon", { colorScheme:"chainindex", color: backboneSchemeId, radiusType: "sstruc" });
          // o.addRepresentation("backbone", { colorScheme: "element",color: backboneSchemeId, radiusType: "sstruc"}); // backbone
          var surfaceChainA = o.addRepresentation("surface", {
            surfaceType: "sas",
            smooth: 2,
            probeRadius: 1.4,
            scaleFactor: 2.0,
            flatShaded: false,
            opacity: 0.3,
            lowResolution: false,
            // colorScale: "Greys"
            color: "#000000",
            side: "front"
          });
          var surfaceChainBC = o.addRepresentation("surface", {
            surfaceType: "sas",
            smooth: 2,
            probeRadius: 1.4,
            scaleFactor: 2.0,
            flatShaded: false,
            opacity: 0.3,
            lowResolution: false,
            // colorScale: "Greys"
            color: "grey",
            side: "front"
          });
          var notAce2ChainA = o.addRepresentation("cartoon", {
            // colorScale: "Greys", 
            color: "#666666", // light dark
            opacity: 0.8,
            radiusType: "sstruc"
          });
          var notAce2ChainBC = o.addRepresentation("cartoon", {
            // colorScale: "Greys", 
            color: "#999999",
            opacity: 0.5,
            radiusType: "sstruc"
          });

          // get full list of resno from the whole structure
          let resnoArray = o.structure.residueStore.resno.filter(item => item !== 0); //TODO: consider to move to constant, don't get everytime, need to print the time
          let tempLabelResnoNotFoundArray = [];
          let variantRange = [];

          for (let i = 0; i < variantNonDelInsPhenoEffectPosArray.length; i++) {
            let pos = parseInt(variantNonDelInsPhenoEffectPosArray[i]);
            if (resnoArray.indexOf(pos) === -1) // pos not found in total resno array
            {
              // find the nearest pos
              let closest = resnoArray.reduce(function (prev, curr) {
                return (Math.abs(curr - pos) < Math.abs(prev - pos) ? curr : prev);
              });
              variantNonDelInsPhenoEffectPosArray[i] = closest.toString();
              tempLabelResnoNotFoundArray.push(variantNonDelInsPhenoEffectArray[i] + "(" + closest.toString() + ")");
            }
          }
          variantRange.push([constColorNonDelInsWithPhenoEffect, variantNonDelInsPhenoEffectPosArray.join(" or ")]);
          // console.debug(variantRange);
          for (let i = 0; i < variantNonDelInsNoPhenoEffectPosArray.length; i++) {
            let pos = parseInt(variantNonDelInsNoPhenoEffectPosArray[i]);
            if (resnoArray.indexOf(pos) === -1) // pos not found in total resno array
            {
              // find the nearest pos
              let closest = resnoArray.reduce(function (prev, curr) {
                return (Math.abs(curr - pos) < Math.abs(prev - pos) ? curr : prev);
              });
              variantNonDelInsNoPhenoEffectPosArray[i] = closest.toString();
              tempLabelResnoNotFoundArray.push(variantNonDelInsNoPhenoEffectArray[i] + "(" + closest.toString() + ")");
            }
          }
          variantRange.push([constColorNonDelInsNoPhenoEffect, variantNonDelInsNoPhenoEffectPosArray.join(" or ")]);

          if (variantDelInsPhenoEffectPosArray.length > 0) {
            for (let i = 0; i < variantDelInsPhenoEffectPosArray.length; i++) {
              let pos = parseInt(variantDelInsPhenoEffectPosArray[i]);
              if (resnoArray.indexOf(pos) === -1) // pos not found in total resno array
              {
                // find the nearest pos
                let closest = resnoArray.reduce(function (prev, curr) {
                  return (Math.abs(curr - pos) < Math.abs(prev - pos) ? curr : prev);
                });
                variantDelInsPhenoEffectPosArray[i] = closest.toString();
                tempLabelResnoNotFoundArray.push(variantDelInsPhenoEffectArray[i] + "(" + closest.toString() + ")");
              }
            }
            variantRange.push([constColorDelInsPhenoEffect, variantDelInsPhenoEffectPosArray.join(" or ")]);
          }
          if (variantDelInsNoPhenoEffectPosArray.length > 0) {
            for (let i = 0; i < variantDelInsNoPhenoEffectPosArray.length; i++) {
              let pos = parseInt(variantDelInsNoPhenoEffectPosArray[i]);
              if (resnoArray.indexOf(pos) === -1) // pos not found in total resno array
              {
                // find the nearest pos
                let closest = resnoArray.reduce(function (prev, curr) {
                  return (Math.abs(curr - pos) < Math.abs(prev - pos) ? curr : prev);
                });
                variantDelInsNoPhenoEffectPosArray[i] = closest.toString();
                tempLabelResnoNotFoundArray.push(variantDelInsNoPhenoEffectArray[i] + "(" + closest.toString() + ")");
              }
            }
            variantRange.push([constColorDelInsNoPhenoEffect, variantDelInsNoPhenoEffectPosArray.join(" or ")]);
          }

          // var variantRange = [
          //   ["#ff3c00", variantArray.join(" or ")], // variant yellow/orange https://www.color-hex.com/color-palette/9840 ff5a00 ff4d00 ff3c00 
          //   ["#4d4db3", coMutsPosArray.join(" or ")] //coMuts blue https://www.color-hex.com/color-palette/115574 326bbb 4040bf
          // ]
          var variantSchemeId = ColormakerRegistry.addSelectionScheme(variantRange, "");
          var hyperball = o.addRepresentation("hyperball", { color: variantSchemeId, radiusType: "covalent", size: 10, scale: 10, opacity: 1, radius: 10 });

          //===========================
          // variants normal non del/ins with pheno effect
          //===========================
          if (variantNonDelInsPhenoEffectPosArray.length > 0) {
            var selectionNonDelIns = "(" + variantNonDelInsPhenoEffectPosArray.join(" or ") + ") and (not :D)";
            var selectionObjectNonDelIns = new Selection(selectionNonDelIns);
            var structure = o.structure;
            var labelText = {};
            structure.eachAtom(function (atomProxy) {
              // if you don't want a label and can't be more specific with the selection
              // set `labelText[atomProxy.index] = ""`
              let pos = variantNonDelInsPhenoEffectPosArray.indexOf(atomProxy.resno.toString());
              if (pos !== -1) {
                labelText[atomProxy.index] = variantNonDelInsPhenoEffectArray[pos];
              } else {
                labelText[atomProxy.index] = "";
              }
            }, selectionObjectNonDelIns);
            o.addRepresentation("label", {
              sele: selectionNonDelIns,
              color: "#111111",
              name: 'myLabelNonDelIns',
              labelType: "text",
              labelText: labelText,
              labelGrouping: "residue",
              showBackground: true,
              radius: 10,
              backgroundColor: constColorNonDelInsWithPhenoEffect,
              xOffset: 5,
              backgroundOpacity: 1
            });
          }
          //===========================

          //===========================
          // variants normal non del/ins NO pheno effect
          //===========================
          if (variantNonDelInsNoPhenoEffectPosArray.length > 0) {

            var selectionNonDelInsNoPhenoEffect = "(" + variantNonDelInsNoPhenoEffectPosArray.join(" or ") + ") and (not :D)";
            var selectionObjectNonDelInsNoPhenoEffect = new Selection(selectionNonDelInsNoPhenoEffect);
            var structure = o.structure;
            var labelText = {};
            structure.eachAtom(function (atomProxy) {
              // if you don't want a label and can't be more specific with the selection
              // set `labelText[atomProxy.index] = ""`
              let pos = variantNonDelInsNoPhenoEffectPosArray.indexOf(atomProxy.resno.toString());
              if (pos !== -1) {
                // console.debug(pos+" match normal "+variantNonDelInsArray[pos]);
                labelText[atomProxy.index] = variantNonDelInsNoPhenoEffectArray[pos];
              } else {
                labelText[atomProxy.index] = "";
              }
            }, selectionObjectNonDelInsNoPhenoEffect);
            o.addRepresentation("label", {
              sele: selectionNonDelInsNoPhenoEffect,
              color: "#111111",
              name: 'myLabelNonDelInsNoPhenoEffect',
              labelType: "text",
              labelText: labelText,
              labelGrouping: "residue",
              showBackground: true,
              radius: 10,
              backgroundColor: constColorNonDelInsNoPhenoEffect,
              xOffset: 5,
              backgroundOpacity: 1
            });
          }
          //===========================

          //===========================
          // variants del/ins with pheno effect
          //===========================
          if (variantDelInsPhenoEffectPosArray.length > 0) {

            var selectionDelInsPhenoEffect = "(" + variantDelInsPhenoEffectPosArray.join(" or ") + ") and (not :D)";
            // console.debug(selectionDelIns);
            var selectionObjectDelIns = new Selection(selectionDelInsPhenoEffect);
            structure.eachAtom(function (atomProxy) {
              // if you don't want a label and can't be more specific with the selection
              // set `labelText[atomProxy.index] = ""`
              let pos = variantDelInsPhenoEffectPosArray.indexOf(atomProxy.resno.toString());
              if (pos !== -1) {
                labelText[atomProxy.index] = variantDelInsPhenoEffectArray[pos];
              } else {
                labelText[atomProxy.index] = "";
              }
            }, selectionObjectDelIns);
            o.addRepresentation("label", {
              sele: selectionDelInsPhenoEffect,
              color: "#111111",
              name: 'myLabelDelInsPhenoEffect',
              labelType: "text",
              labelText: labelText,
              labelGrouping: "residue",
              showBackground: true,
              radius: 10,
              backgroundColor: constColorDelInsPhenoEffect,
              xOffset: 5,
              backgroundOpacity: 1
            });
          }
          //===========================

          //===========================
          // variants del/ins no pheno effect
          //===========================
          if (variantDelInsNoPhenoEffectPosArray.length > 0) {

            var selectionDelInsNoPhenoEffect = "(" + variantDelInsNoPhenoEffectPosArray.join(" or ") + ") and (not :D)";
            // console.debug(selectionDelIns);
            var selectionObjectDelInsNoPhenoEffect = new Selection(selectionDelInsNoPhenoEffect);
            structure.eachAtom(function (atomProxy) {
              // if you don't want a label and can't be more specific with the selection
              // set `labelText[atomProxy.index] = ""`
              let pos = variantDelInsNoPhenoEffectPosArray.indexOf(atomProxy.resno.toString());
              if (pos !== -1) {
                labelText[atomProxy.index] = variantDelInsNoPhenoEffectArray[pos];
              } else {
                labelText[atomProxy.index] = "";
              }
            }, selectionObjectDelInsNoPhenoEffect);
            o.addRepresentation("label", {
              sele: selectionDelInsNoPhenoEffect,
              color: "#111111",
              name: 'myLabelDelIns',
              labelType: "text",
              labelText: labelText,
              labelGrouping: "residue",
              showBackground: true,
              radius: 10,
              backgroundColor: constColorDelInsNoPhenoEffect,
              xOffset: 5,
              backgroundOpacity: 1
            });
          }
          //===========================

          // o.addRepresentation("ball+stick", { color: variantSchemeId, radiusType: 'sstruc', radiusSize: 20 });  // pass schemeId here
          // stage.toggleFullscreen(stage);

          notAce2ChainA.setSelection(":A");
          notAce2ChainBC.setSelection(":B or :C")
          // notAce2.setSelection("not :D");
          ace2.setSelection(":D");
          surfaceChainA.setSelection(":A");
          surfaceChainBC.setSelection(":B or :C");
          // surface.setSelection("not :D");
          // hyperball.setSelection("(" + variantPosArray.join(" or ") + " or " + coMutsPosArray.join(" or ") + ") and (not :D)");
          hyperball.setSelection("(" + variantNonDelInsPhenoEffectPosArray.join(" or ") + " or " + variantNonDelInsNoPhenoEffectPosArray.join(" or ") + " or " + variantDelInsPhenoEffectPosArray.join(" or ") + " or " + variantDelInsNoPhenoEffectPosArray.join(" or ") + ") and (not :D)");

          if (tempLabelResnoNotFoundArray.length > 0) {
            setLabelResnoNotFound("For " + tempLabelResnoNotFoundArray.join(", ") + ": (nearest residue highlighted in structure if in loop/termini region)");
          }

          //add legend
          const legendStartPos = 95, legendLineMargin = 1, legendLineHeight = 10;
          let pos = legendStartPos;
          addElement(createElement("span", {}, { top: legendStartPos + "px", left: "15px", height: legendLineHeight + "px", width: "10px", backgroundColor: constColorNonDelInsWithPhenoEffect, color: constColorNonDelInsWithPhenoEffect, borderRadius: "2px" }))
          addElement(createElement("label", { innerText: "Variant with documented pheno effects" }, { top: (legendStartPos - 1) + "px", left: "29px", height: legendLineHeight + "px", color: "#000000", fontSize: "10px" }))
          // legend for variants del/ins
          if (variantDelInsPhenoEffectPosArray.length > 0) {
            pos += legendLineHeight + legendLineMargin;
            addElement(createElement("span", {}, { top: pos + "px", left: "15px", height: legendLineHeight + "px", width: "10px", backgroundColor: constColorDelInsPhenoEffect, color: constColorDelInsPhenoEffect, borderRadius: "2px" }))
            addElement(createElement("label", { innerText: "Variant (insertions/deletions) with documented pheno effects" }, { top: (pos - 1) + "px", left: "29px", height: legendLineHeight + "px", color: "#000000", fontSize: "10px" }))
          }
          // legend for variants no pheno effects
          if (variantNonDelInsNoPhenoEffectPosArray.length > 0 || variantDelInsNoPhenoEffectPosArray.length > 0) {
            pos += legendLineHeight + legendLineMargin;
            addElement(createElement("span", {}, { top: pos + "px", left: "15px", height: legendLineHeight + "px", width: "10px", backgroundColor: constColorNonDelInsNoPhenoEffect, color: constColorNonDelInsNoPhenoEffect, borderRadius: "2px" }))
            addElement(createElement("label", { innerText: "Variant without documented pheno effects" }, { top: (pos - 1) + "px", left: "29px", height: legendLineHeight + "px", color: "#000000", fontSize: "10px" }))
          }

          // labelResnoNotFoundContainer.current.text = tempLabelResnoNotFoundArray.join(",");
          stage.autoView();

          // below two settings must be after autoView() in order to customise the initial state
          o.setScale(1.3);
          o.setPosition([-10, 35, 0]);

          stage.setSpin(true);
        });

        // if(document.getElementById("loader3DSpikeMutations")!==null)
        if(loader3DSpikeMutations.current) loader3DSpikeMutations.current.style.display = "none";
        // document.getElementById("viewportContainer").style.display = "block";
        // if(document.getElementById("btnContainer")!==null)
        if(btnContainer.current)btnContainer.current.style.display = "block";

        if(btnSaveAsImage.current)
          btnSaveAsImage.current.addEventListener("click", () => {
            stage.viewer.makeImage().then(function (image) {
              saveAs(image, "3DStructureSpikeMutations-" + variant + ".png");
            });
            // savefile(stage.viewer); // to save continuous 50 files
          });

        if(btnSpin.current)
          btnSpin.current.addEventListener("click", () => {
            stage.toggleSpin();
          })

        if(btnFullscreen.current)
          btnFullscreen.current.addEventListener("click", () => {
            stage.toggleFullscreen();
          })

        if(btnLiteratureRef.current)
        btnLiteratureRef.current.addEventListener("click", (e) => {
          handleLiteratureClick(e);
        })

        // return () => {
        //     stage.removeAllComponents();
        //     stage.dispose();
        //   };
      }
      // }
      // , [] // put the array as empty to let the effect to call only once
      // );
    // }
    // );
  }
    // it's when modal unmounted, below method will be called. used to clear objects. for better performance 20211026
    return () => {
      if(stage){
        // console.debug("removeAllcomponents...");
        
        // to clear the legends
        const elem = stage.viewer.container.querySelectorAll('span, label');
        elem.forEach(e => e.remove());

        stage.removeAllComponents();
      // stage.dispose();
      }
    };
  }, [result,stage]);


  return (
    <React.Fragment >
      <div style={{ textAlign: 'center', fontSize: 11 }}>
        SARS-CoV-2 spike glycoprotein trimer (3 units shown, gray ribbons) in complex with human host cell receptor ACE2 (1 unit shown, <text style={{ color: constColorNonDelInsNoPhenoEffect, fontWeight: 'bold' }}>green</text> ribbon).<br />
        Positions with changes in the {lineageNameInDescription} are indicated as colored balls. Changes with documented phenotypic effects from literature are colored <text style={{ color: constColorNonDelInsWithPhenoEffect, fontWeight: 'bold' }}>light orange</text> or <text style={{ color: constColorDelInsPhenoEffect, fontWeight: 'bold' }}>cyan</text> for insertions/deletions while others without documented phenotypic effects are colored in <text style={{ color: constColorNonDelInsNoPhenoEffect, fontWeight: 'bold' }}>green</text>.
      </div>
      <div ref={loader3DSpikeMutations} className={Style.loader} />
      <div id="viewportContainer" style={{ display: 'block' }}>
        <div className={Style.download} ref={btnContainer}>
          <button
            ref={btnSpin}
            type="button"
            title="Toggle spin on or off"
            className={Style.buttonInStructure}
            style={{ marginRight: 5,borderRadius: '6px',boxShadow: '0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%)',border:'2px solid grey'}}>
            <MdWifiProtectedSetup/>
          </button>
          <button
            ref={btnFullscreen}
            type="button"
            title="Toggle full screen"
            className={Style.buttonInStructure}
            style={{ marginRight: 5 }}>
            <MdOpenInFull/>
          </button>
          <button
            ref={btnSaveAsImage}
            title="Save as png file"
            type="button"
            className={Style.buttonInStructure}
            style={{ marginRight: 5 }}
          >
            {/* <img alt="PNG" src="csv.png" width="15" height="15" /> */}
            <GrDownload />
          </button>
          <button
            type="button"
            ref={btnLiteratureRef}
            title="Literature References"
            className={Style.buttonInStructure}
          >
            <GrCatalog/>
          </button>
        </div>
        <div id="viewPortContainer2" className={Style.viewportstyle}>
          <div id="viewport3dStructure" style={{ width: 500, height: 380 }} ></div>
        </div>

        <div style={{ textAlign: 'center', fontSize: 11 }}>
          {labelResnoNotFound}
        </div>
      </div>

      {<div><Modal
        show={visible}
        onHide={() => setVisible(false)}
        dialogClassName={Style.modalw90}
        aria-labelledby="example-custom-modal-styling-title"
        scrollable="true"
      >
        {/* <button onClick={e => handleCloseModal(e)}>Close Modal</button> */}
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
          <div className={Style.topDisclaimer}>{topDisclaimerIn3DStructModal}</div>
            <div className={Style.modalTitle}>List of relevant literature references curated in CoVsurver</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <BTable striped bordered hover size="sm" responsive="xl" >
                <thead>
                  <tr>
                    <th>AA Change</th>
                    <th>Virus Type</th>
                    <th>Mutation In Paper</th>
                    <th>Effects</th>
                    <th>CoVsurver Comments</th>
                    <th>Neutral AA </th>
                    <th>Negative AA </th>
                    <th>Reference</th>
                  </tr>
                </thead>
                <tbody >
                  {literatureRef.map(ref => {
                    return <tr><td>{ref.aa_change}</td>
                      <td>{ref.virus_type}</td>
                      <td>{ref.mut_in_paper}</td>
                      <td>{ref.effects}</td>
                      <td><div className={Style.comments}>{ref.covsurver_comments}</div></td>
                      <td>{ref.neutral_aa}</td>
                      <td>{ref.negative_aa}</td>
                      <td><a href={ref.reference}><div className={Style.reference}>{ref.reference}</div></a></td>
                    </tr>
                      ;
                  })}
                </tbody>
              </BTable>
            </Row></Container>
        </Modal.Body>
      </Modal></div>}
    </React.Fragment>
  )
    ;
};

export default PDBStructureBase;
